module.exports = __webpack_public_path__ + "static/media/Goose.svg";